import { useCallback } from "react";
import { useTranslation } from "Shared/util/custom-hooks";
import { formatDate } from "Shared/util/formatters";
import { FinaComputedConsentStatus } from "Shared/util/types/api";
import { ConsentItem } from "../types";

export const useGetConsentStateText = () => {
    const t = useTranslation(
        (x) => x.company_settings.payoutInformationPage.consentCards.card,
    );

    return useCallback(
        (
            status: ConsentItem["status"],
            expiresAt: ConsentItem["expiresAt"],
        ) => {
            switch (status) {
                case FinaComputedConsentStatus.Expired:
                    return t.format(t.expiredAt, {
                        expiredAt: formatDate(expiresAt),
                    });

                case FinaComputedConsentStatus.NotProvided:
                    return t.consentMissing;

                case FinaComputedConsentStatus.ExpiresSoon:
                case FinaComputedConsentStatus.Provided:
                    return t.format(t.expiresAt, {
                        expiresAt: formatDate(expiresAt),
                    });

                case FinaComputedConsentStatus.NotRequired:
                default:
                    return "";
            }
        },
        [t],
    );
};
